{#each refs as ref}
  <BibleRef_Single {ref} />{ref.separator}
{/each}

<script lang="ts">
  // Tested by: app/javascript/@svelte/test/BibleRef.svelte

  import parse_bible_ref from 'common/bible/parse_bible_ref'
  import type { BibleRef } from 'common/bible/parse_bible_ref'
  import BibleRef_Single from '@svelte/common/BibleRef_Single.svelte'

  export let ref

  let refs: BibleRef[]

  $: refs = [...parse_bible_ref(ref)]
  // $: console.log(refs)
</script>
